import { serializeValue } from './serialize-value';
/**
 * Serialises a given value to a string that can be de-serialised back to it's original type.
 */
export const stringify = (value) => {
    if (typeof value === 'string')
        return value; // Strings do not need to be stringified
    const serializedValue = serializeValue(value); // Some types need to be serialized before stringifying
    return JSON.stringify(serializedValue);
};
//# sourceMappingURL=stringify.js.map